/**
 * 32-bit FNV-1a hash of a string's UTF-16 code units, as an unsigned integer. Tiny, stable across
 * runtimes (API, web, landing) and good enough for picking a stable variant or fingerprinting content.
 * Not a cryptographic hash: never use it for anything an attacker must not be able to collide.
 */
export function fnv1aHash32(value: string): number {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash;
}
